import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

// The weekly schedule editor: add and remove time windows inside a weekday.
// Nothing is saved here — the whole grid is submitted with the form, which is
// what makes "a day with no windows" expressible at all.
class AvailabilityController extends Controller {
  static targets = ['windows', 'window', 'empty', 'template']

  add (event) {
    const day = event.currentTarget.dataset.day
    const container = this.windowsTargets.find((element) => element.dataset.day === day)
    const index = container.querySelectorAll('.availability__window').length

    const markup = this.templateTarget.innerHTML
      .replace(/DAY/g, day)
      .replace(/INDEX/g, `${index}-${Date.now()}`)

    container.insertAdjacentHTML('afterbegin', markup)
    this.#toggleEmpty(container)
  }

  remove (event) {
    const window = event.currentTarget.closest('.availability__window')
    const container = window.closest('.availability__windows')

    window.remove()
    this.#toggleEmpty(container)
  }

  #toggleEmpty (container) {
    const empty = container.querySelector('.availability__unavailable')
    if (!empty) return

    empty.hidden = container.querySelectorAll('.availability__window').length > 0
  }
}

stimulus.register('availability', AvailabilityController)

export default AvailabilityController
